const env = 'prod'; // set env to 'dev','test','prod' linked to related URL

////

const dev = {
 app: {
   baseUrl : 'http://localhost:63787/',
   tokenUrl : 'http://localhost:63787/CP/token/gettoken',
   integtokenUrl : 'https://gilmartins-integration-scheduled-lookahead-test.azurewebsites.net/specialdynamicauth?id=e73a1e30-50de-ea11-a813-000d3a0bad17',
   booknewapptUrl : 'https://gilm-clientportal-test.azurewebsites.net/CP/WorkOrders/bookNewAppointment',
   
   schedulingbaseUrl : 'http://localhost:1500/api/scheduling/',
   getaccountbaseUrl : 'https://gilmartins-dev.crm11.dynamics.com/api/data/v9.2/accounts',
   getusrauthbaseUrl : 'https://gilmartins-dev.crm11.dynamics.com/api/data/v9.2/exactly_portalusers',
   getinvoiceguidUrl : '',
   getinvoicedownloadUrl : '',
   //for documents
   getazuremediaUrl : '',
   downloadazuremediaUrl : '',
   downloadazureToken : ''
 },
 db: {
 },
 environment : env
};

const test = {
 app: {
   baseUrl : 'https://gilm-clientportal-test.azurewebsites.net/',
   tokenUrl : 'https://gilm-clientportal.azurewebsites.net/CP/token/gettoken',
   integtokenUrl : 'https://gilmartins-integration-scheduled-lookahead-test.azurewebsites.net/specialdynamicauth?id=e73a1e30-50de-ea11-a813-000d3a0bad17',
   booknewapptUrl : 'https://gilm-clientportal-test.azurewebsites.net/CP/WorkOrders/bookNewAppointment',
   
   schedulingbaseUrl : 'https://lookaheadintegrationapi.azurewebsites.net/api/scheduling/',
   getaccountbaseUrl : 'https://gilmartins-test.crm11.dynamics.com/api/data/v9.2/accounts',
   getusrauthbaseUrl : 'https://gilmartins-test.crm11.dynamics.com/api/data/v9.2/exactly_portalusers',
   getinvoiceguidUrl : 'https://gilmartins-test.crm11.dynamics.com/api/data/v9.2/msdyn_workorders',
   getinvoicedownloadUrl : '',
   //for note
   getclientnoteUrl : 'https://gilmartins-test.crm11.dynamics.com/api/data/v9.2/annotations',
   //for documents
   getazuremediaUrl : 'https://azuredataprocesser.azurewebsites.net/api/Azure/',
   downloadazuremediaUrl : 'https://gilmartinsd365storage.blob.core.windows.net/documents/',
   downloadazureToken : '?sp=r&st=2025-11-07T15:49:25Z&se=2027-11-19T00:04:25Z&spr=https&sv=2024-11-04&sr=c&sig=IjAj%2FfjDCBeJ%2FGgRvU0vmOS1fkhyn%2BzK0SA64LdMNwM%3D'
 },
 db: {
 },
 environment : env
};
////
const prod = {
  app: {
    baseUrl : 'https://gilm-clientportal.azurewebsites.net/',
    tokenUrl : 'https://gilm-clientportal.azurewebsites.net/CP/token/gettoken',
    integtokenUrl : 'https://gilmartins-integration-scheduled-lookahead.azurewebsites.net/specialdynamicauth?id=e73a1e30-50de-ea11-a813-000d3a0bad17',
    booknewapptUrl : 'https://gilm-clientportal.azurewebsites.net/CP/WorkOrders/bookNewAppointment',
    schedulingbaseUrl : 'https://lookaheadintegrationapi.azurewebsites.net/api/scheduling/',
    getaccountbaseUrl : 'https://gilmartins.crm11.dynamics.com/api/data/v9.2/accounts',
    getusrauthbaseUrl : 'https://gilmartins.crm11.dynamics.com/api/data/v9.2/exactly_portalusers',
    getinvoiceguidUrl : 'https://gilmartins.crm11.dynamics.com/api/data/v9.2/msdyn_workorders',
    getinvoicedownloadUrl : 'https://invoicecreation-automation.azurewebsites.net/invoice/pdf/load/',
    //for note
    getclientnoteUrl : 'https://gilmartins.crm11.dynamics.com/api/data/v9.2/annotations',
    //for documents
    getazuremediaUrl : 'https://azuredataprocesser.azurewebsites.net/api/Azure/',
    downloadazuremediaUrl : 'https://gilmartinsd365storage.blob.core.windows.net/documents/',
    downloadazureToken : '?sp=r&st=2025-11-07T15:49:25Z&se=2027-11-19T00:04:25Z&spr=https&sv=2024-11-04&sr=c&sig=IjAj%2FfjDCBeJ%2FGgRvU0vmOS1fkhyn%2BzK0SA64LdMNwM%3D'
  },
  db: {
  },
  environment : env
 };
 
const config = {
 dev,
 test,
 prod
};

export default config[env];